<template>
    <ion-label>
        <div v-if="$root.isMobileOrSmall">
            <p>{{ participant.display_name }}</p>
        </div>
        <ion-chip v-else @click="openParticipant($event)" button>
            <ion-avatar>
                <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjYzVkYmZmIiBkPSJNMCAwaDUxMnY1MTJIMHoiLz48cGF0aCBkPSJNMjU2IDMwNGM2MS42IDAgMTEyLTUwLjQgMTEyLTExMlMzMTcuNiA4MCAyNTYgODBzLTExMiA1MC40LTExMiAxMTIgNTAuNCAxMTIgMTEyIDExMnptMCA0MGMtNzQuMiAwLTIyNCAzNy44LTIyNCAxMTJ2NTZoNDQ4di01NmMwLTc0LjItMTQ5LjgtMTEyLTIyNC0xMTJ6IiBmaWxsPSIjODJhZWZmIi8+PC9zdmc+"
                     alt="">
            </ion-avatar>
            <ion-label>{{ participant.display_name }}</ion-label>
            <receive-status-progress-marks v-if="participant.receive_status" :statusDetails="participant.receive_status"/>
        </ion-chip>
    </ion-label>
</template>

<script>
    import ParticipantDetailsPopover from "../nav/ParticipantDetailsPopover";
    import ReceiveStatusProgressMarks from "../ui-elements/ReceiveStatusProgressMarks";

    export default {
        name: "MessageParticipant",
        components: {ReceiveStatusProgressMarks},
        props: {
            participant: {type: Object},
        },
        methods: {
            async openParticipant(event) {
                const popover = await this.$ionic.popoverController
                    .create({
                        component: ParticipantDetailsPopover,
                        componentProps: {
                            parent: this,
                            propsData: {
                                participant: this.participant,
                            },
                        },
                        event,
                    });

                await popover.present();
            }
        },
    }
</script>
